import React, { useRef, useEffect, useCallback } from "react";
import { Line } from "react-chartjs-2";
import styles from "./Style.module.css";
import { Typography } from "@mui/material";
import NoDataFound from "../NoDataFound/NoDataFound";
import { FileDownloadOutlined } from "@mui/icons-material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const TrendChart = ({
  trendData = [],
  dataSet = [],
  title = "",
  height = 250,
  isImgDownload = false,
  isExpand = false,
  onExpand,
  isExport,
  handleExport,
  downloadTitle = "",
}) => {
  const chartRef = useRef(null);

  const data = {
    labels: trendData?.label || [],
    datasets: [...dataSet],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      backgroundColor: "#ffffff",
      titleFontColor: "#161616",
      bodyFontColor: "#333333",
    },
    scales: {
      xAxes: [
        {
          gridLines: {
            color: "rgba(187, 187, 187, 1)3)",
            borderColor: "rgba(187, 187, 187, 1)",
            lineWidth: 1,
          },
          ticks: {
            autoSkip: false,
          },
        },
      ],
      yAxes: [
        {
          gridLines: {
            color: "rgba(187, 187, 187, 1)",
            borderColor: "rgba(187, 187, 187, 1)",
            lineWidth: 1,
          },
          ticks: {
            beginAtZero: true,
            callback: function (value) {
              return `${value.toLocaleString()}`;
            },
          },
        },
      ],
    },
  };

  const chartWidth = Math.max((trendData?.label?.length || 0) * 100, 400);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const chart = chartRef.current;
      if (chart && chart.chartInstance) {
        chart.chartInstance.resize();
        chart.chartInstance.update();
      }
    }, 300);

    return () => clearTimeout(timeout);
  }, [trendData]);

  const handleDownload = useCallback(() => {
    if (!chartRef.current) return;

    const chart = chartRef.current;
    const canvas = chart.chartInstance.canvas;
    const ctx = canvas.getContext("2d");

    const paddingTop = 40;
    const tempCanvas = document.createElement("canvas");
    tempCanvas.width = canvas.width;
    tempCanvas.height = canvas.height + paddingTop;
    const tempCtx = tempCanvas.getContext("2d");

    tempCtx.fillStyle = "white";
    tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

    tempCtx.fillStyle = "#636578";
    tempCtx.font = "bold 16px Arial";
    tempCtx.textBaseline = "top";
    tempCtx.fillText(title || "Chart Title", 10, 10);

    tempCtx.drawImage(canvas, 0, paddingTop);

    const url = tempCanvas.toDataURL("image/png");
    const a = document.createElement("a");
    a.href = url;
    a.download = `${title || "chart"}.png`;
    a.click();
  }, [chartRef, title]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.dFlex}>
          <Typography variant="h5" className="heading">
            {title}
          </Typography>
          {isExpand && (
            <OpenInNewIcon
              onClick={onExpand}
              color="primary"
              size="small"
              className={styles.expandIcon}
            />
          )}
          {isImgDownload && (
            <FileDownloadOutlined
              onClick={handleDownload}
              color="primary"
              fontSize="small"
              className={styles.downloadIcon}
            />
          )}
        </div>

        {isExport && (
          <div className={styles.dFlex2}>
            <Typography variant="h5" className="heading">
              {downloadTitle}
            </Typography>
            <FileDownloadOutlined
              onClick={handleExport}
              color="primary"
              size="small"
              className={styles.expandIcon}
            />
          </div>
        )}
        {/* <div className={styles.ddWrap}></div> */}
      </div>
      <div className={styles.ddWrap1}>
        {dataSet?.map((val, i) => (
          <div key={i} className={styles.dotWrapper}>
            <div
              className={styles.dot}
              style={{ background: val?.pointBackgroundColor }}
            ></div>
            <div>
              {val?.label?.includes("Redemption") ||
              val?.label?.includes("Earned")
                ? "Redemption Ratio"
                : val?.label}
            </div>
          </div>
        ))}
      </div>
      {trendData?.label?.length > 0 ? (
        <div className={styles.scrollWrapper}>
          <div
            className={styles.chartInner}
            style={{
              minWidth:
                trendData?.label?.length > 8 ? `${chartWidth}px` : "100%",
              height: height,
            }}
          >
            <Line ref={chartRef} data={data} options={options} />
          </div>
        </div>
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};

export default TrendChart;
